import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Assets klasöründeki görselleri import ediyoruz
import friendsBirthday from '../assets/-friends-celebrating-birthday--one-person-blows-ou.png';
import image from '../assets/image.png';
import kidBoy from '../assets/k---k-erkek--ocuk-padi-ah-kost-m--ile-.png';
import weddingHenna from '../assets/kapal--m-sl-man-gelin-eline-k-na-yakm----ekilde-ot.png';
import beachProposal from '../assets/man-proposes-to-woman-on-the-beach-.png';
import graduation from '../assets/students-celebrating-graduation---.png';
import engagement from '../assets/the-groom-and-bride-who-organized-the-engagement--.png';

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();

    // Slider için görseller ve başlıkları
    const slides = [
        {
            image: friendsBirthday,
            title: "🎉 Doğum Günü Kutlamaları",
            description: "Sevdiklerinizin özel gününe yakışır renkli ve eğlenceli davetiyeler"
        },
        {
            image: image,
            title: "✨ Kurumsal Etkinlikler",
            description: "Hayatınızın her güzel anını dijital sanatla buluşturun"
        },
        {
            image: kidBoy,
            title: "👑 Sünnet Düğünü",
            description: "Miniklerinizin hayal dünyasına uygun masalımsı davetiyeler"
        },
        {
            image: weddingHenna,
            title: "🌙 Kına Gecesi",
            description: "Geleneksel zarafet ve modern dokunuşlarla büyülü bir gece"
        },

        {
            image: beachProposal,
            title: "💍 Düğün",
            description: "Aşkınızın en büyük adımı için romantik ve kalp dokuyan anlar"
        },
        {
            image: graduation,
            title: "🎓 Mezuniyet Töreni",
            description: "Başarının taçlandığı an - geleceğe açılan kapılar için"
        },
        {
            image: engagement,
            title: "💕 Nişan Töreni ve Söz Töreni",
            description: "İki kalbin birleştiği an - aşkın resmi başlangıcı için"
        }
    ];

    // Otomatik slide geçişi
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 4000);
        return () => clearInterval(interval);
    }, [slides.length]);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    return (
        <section id="hero" className="relative bg-gradient-to-br from-white via-gray-50 to-primary-50 py-16 lg:py-24 overflow-hidden">
            {/* Arka plan dekoratif elementler */}
            <div className="absolute inset-0">
                <div className="absolute top-20 left-10 w-32 h-32 bg-primary-100 rounded-full opacity-20 animate-float"></div>
                <div className="absolute bottom-20 right-10 w-24 h-24 bg-primary-200 rounded-full opacity-30 animate-pulse-slow"></div>
                <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-dark-200 rounded-full opacity-10 animate-bounce-slow"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    {/* Sol taraf - Metin İçeriği */}
                    <div className="text-center lg:text-left animate-slide-right">
                        {/* Üst etiket */}
                        <div className="inline-block bg-gradient-to-r from-primary-100 to-primary-200 text-primary-800 px-6 py-3 rounded-full text-sm font-semibold mb-8 animate-fade-in shadow-lg">
                            ✨ Özel Günleriniz İçin Modern Çözüm
                        </div>

                        {/* Ana başlık */}
                        <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-dark-900 mb-8 leading-tight animate-slide-up">
                            Dijital Davetiyelerle{' '}
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800 animate-pulse">
                                Özel Anlarınızı
                            </span>{' '}
                            Paylaşın
                        </h1>

                        {/* Açıklama */}
                        <p className="text-lg text-dark-600 mb-10 leading-relaxed max-w-xl animate-slide-up" style={{ animationDelay: '0.2s' }}>
                            Düğün, nişan, kına gecesi ve doğum günü gibi özel günleriniz için
                            kişiselleştirilmiş, şık ve modern dijital davetiyeler. Kağıt
                            davetiyeler yerine çevre dostu, kolay paylaşılabilen ve etkileşimli
                            çözümler.
                        </p>

                        {/* Butonlar */}
                        <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start animate-slide-up" style={{ animationDelay: '0.4s' }}>
                            <button 
                                onClick={() => navigate('/calismalarimiz')}
                                className="group bg-gradient-to-r from-primary-600 to-primary-700 text-white px-8 py-4 rounded-xl hover:from-primary-700 hover:to-primary-800 transition-all duration-300 font-semibold text-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-2 hover:scale-105"
                            >
                                <span className="flex items-center justify-center space-x-2">
                                    <span>Davetiyeleri İncele</span>
                                    <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>

                    {/* Sağ taraf - Kart Stack Slider */}
                    <div className="flex justify-center lg:justify-end animate-slide-up" style={{ animationDelay: '0.6s' }}>
                        <div className="relative w-full max-w-sm sm:max-w-md lg:max-w-lg h-[350px] sm:h-[400px] lg:h-[500px]">
                            {/* Kart Stack Container */}
                            <div className="relative w-full h-full perspective-1000">
                                {slides.map((slide, index) => {
                                    // Mevcut kartın pozisyonunu hesaplama
                                    const isActive = index === currentSlide;
                                    const isNext = index === (currentSlide + 1) % slides.length;
                                    const isPrev = index === (currentSlide - 1 + slides.length) % slides.length;

                                    // Z-index hesaplama (aktif kart en üstte)
                                    let zIndex = slides.length - Math.abs(index - currentSlide);
                                    if (index > currentSlide && (index - currentSlide) > slides.length / 2) {
                                        zIndex = slides.length - (slides.length - index + currentSlide);
                                    } else if (index < currentSlide && (currentSlide - index) > slides.length / 2) {
                                        zIndex = slides.length - (slides.length - currentSlide + index);
                                    }

                                    // Transform hesaplama
                                    let transform = '';
                                    let opacity = 1;

                                    if (isActive) {
                                        transform = 'translateY(0px) scale(1) rotateZ(0deg)';
                                        opacity = 1;
                                    } else if (isNext) {
                                        transform = 'translateY(-20px) translateX(15px) scale(0.95) rotateZ(5deg)';
                                        opacity = 0.8;
                                    } else if (isPrev) {
                                        transform = 'translateY(-20px) translateX(-15px) scale(0.95) rotateZ(-5deg)';
                                        opacity = 0.8;
                                    } else {
                                        // Diğer kartlar daha arkada
                                        const distance = Math.abs(index - currentSlide);
                                        const offsetX = (index > currentSlide ? 25 : -25) + (distance * 5);
                                        const offsetY = -30 - (distance * 10);
                                        const scale = 0.9 - (distance * 0.05);
                                        const rotation = (index > currentSlide ? 8 : -8) + (distance * 2);
                                        transform = `translateY(${offsetY}px) translateX(${offsetX}px) scale(${scale}) rotateZ(${rotation}deg)`;
                                        opacity = Math.max(0.3, 0.9 - (distance * 0.2));
                                    }

                                    return (
                                        <div
                                            key={index}
                                            className="absolute inset-0 transition-all duration-700 ease-out cursor-pointer"
                                            style={{
                                                zIndex: zIndex,
                                                transform: transform,
                                                opacity: opacity
                                            }}
                                            onClick={() => setCurrentSlide(index)}
                                        >
                                            {/* Kart */}
                                            <div className="relative w-full h-72 sm:h-80 lg:h-96 bg-white rounded-2xl shadow-2xl overflow-hidden hover:shadow-3xl transition-all duration-300 transform hover:scale-105">
                                                <img
                                                    src={slide.image}
                                                    alt={slide.title}
                                                    className="w-full h-full object-cover"
                                                />
                                                {/* Kart üzerinde bilgi katmanı */}
                                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/85 via-purple-900/30 to-transparent p-6 text-white">
                                                    <h3 className="text-xl font-bold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white via-yellow-200 to-pink-200 drop-shadow-lg">
                                                        {slide.title}
                                                    </h3>
                                                    <p className="text-sm leading-relaxed text-gray-100 font-medium tracking-wide drop-shadow-md">
                                                        {slide.description}
                                                    </p>
                                                </div>

                                                {/* Aktif kart için parlama efekti */}
                                                {isActive && (
                                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-pulse"></div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {/* Navigation Buttons */}
                            <div className="absolute left-2 md:left-0 top-1/2 transform -translate-y-1/2 z-10">
                                <button
                                    onClick={prevSlide}
                                    className="bg-white/90 backdrop-blur-sm hover:bg-white text-dark-700 hover:text-primary-600 p-3 md:p-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110 border border-gray-200"
                                >
                                    <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>
                            </div>

                            <div className="absolute right-2 md:right-0 top-1/2 transform -translate-y-1/2 z-10">
                                <button
                                    onClick={nextSlide}
                                    className="bg-white/90 backdrop-blur-sm hover:bg-white text-dark-700 hover:text-primary-600 p-3 md:p-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-110 border border-gray-200"
                                >
                                    <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>

                            {/* Slide Indicators */}
                            <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-3 z-30">
                                {slides.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setCurrentSlide(index)}
                                        className={`transition-all duration-300 rounded-full ${index === currentSlide
                                            ? 'w-8 h-3 bg-primary-600 scale-125'
                                            : 'w-3 h-3 bg-gray-300 hover:bg-primary-400'
                                            }`}
                                    />
                                ))}
                            </div>

                            {/* Çevredeki dekoratif elementler */}
                            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-primary-400 to-primary-500 rounded-full w-8 h-8 opacity-30 animate-bounce-slow"></div>
                            <div className="absolute -bottom-6 -left-6 bg-gradient-to-r from-dark-400 to-dark-500 rounded-full w-12 h-12 opacity-20 animate-float" style={{ animationDelay: '2s' }}></div>
                            <div className="absolute top-1/3 -right-3 bg-primary-300 rounded-full w-4 h-4 opacity-40 animate-ping" style={{ animationDelay: '1s' }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;